export default __webpack_public_path__ + "static/media/ig-icon-lg.20cd1a04.png";